export class WebhookV1StandardPayloadRestoreJobFailed {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadRestoreJobFailedTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadRestoreJobFailedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadRestoreJobFailed.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadRestoreJobFailedTypeEnum;
(function (WebhookV1StandardPayloadRestoreJobFailedTypeEnum) {
    WebhookV1StandardPayloadRestoreJobFailedTypeEnum["RestoreJobFailed"] = "RESTORE_JOB_FAILED";
})(WebhookV1StandardPayloadRestoreJobFailedTypeEnum || (WebhookV1StandardPayloadRestoreJobFailedTypeEnum = {}));
